import { CardSvg } from '@/play/cardSvg'

/**
 * Home card art for Sand letters (no text): a sand tray seen from above and in front, a finger's
 * trench down the left of an A with the gold letter on its dark board showing at its bottom, the
 * rest still faintly under the sand.
 */
export function SandLettersCardArt() {
  return (
    <CardSvg bg="#cfe9f2">
      <path d="M30 180 L 70 40 H 250 L 290 180 Z" fill="#9b6b43" />
      <path d="M44 170 L 79 52 H 241 L 276 170 Z" fill="#ead6a6" />
      {/* the hint: the whole A, faintly */}
      <path d="M118 150 L 160 66 L 202 150 M 134 120 H 186" fill="none" stroke="#efcf86" strokeWidth="13" strokeLinecap="round" strokeLinejoin="round" />
      {/* the trench written so far: the first leg, the letter at its bottom */}
      <path d="M160 66 L 118 150" fill="none" stroke="#c9a86e" strokeWidth="22" strokeLinecap="round" />
      <path d="M160 66 L 118 150" fill="none" stroke="#5a3b26" strokeWidth="15" strokeLinecap="round" />
      <path d="M160 66 L 118 150" fill="none" stroke="#ffc93c" strokeWidth="9" strokeLinecap="round" />
      {[[70, 150], [96, 92], [222, 120], [240, 160], [210, 72]].map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r="2.4" fill="#c9a86e" />)}
    </CardSvg>
  )
}
